// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts,js_import_style=legacy_commonjs"
// @generated from file fusebase/app_analytics/v1/events.proto (package fusebase.app_analytics.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });

const { proto3 } = require("@bufbuild/protobuf");
const { Timestamp } = require("../../../google/protobuf/timestamp_pb.js");
const { EventContext, EventContextFilter } = require("./event_context_pb.js");
const { User } = require("./users_pb.js");

/**
 * @generated from enum fusebase.app_analytics.v1.EventSortField
 */
const EventSortField = /*@__PURE__*/ proto3.makeEnum(
  "fusebase.app_analytics.v1.EventSortField",
  [
    {no: 0, name: "EVENT_SORT_FIELD_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "EVENT_SORT_FIELD_TIMESTAMP", localName: "TIMESTAMP"},
  ],
);

/**
 * @generated from message fusebase.app_analytics.v1.UserViewedPage
 */
const UserViewedPage = /*@__PURE__*/ proto3.makeMessageType(
  "fusebase.app_analytics.v1.UserViewedPage",
  () => [
    { no: 1, name: "page_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "page_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "page_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 100, name: "as_string", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fusebase.app_analytics.v1.UserEnteredBlockEditMode
 */
const UserEnteredBlockEditMode = /*@__PURE__*/ proto3.makeMessageType(
  "fusebase.app_analytics.v1.UserEnteredBlockEditMode",
  () => [
    { no: 1, name: "block_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "block_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 100, name: "as_string", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fusebase.app_analytics.v1.UserExitedBlockEditMode
 */
const UserExitedBlockEditMode = /*@__PURE__*/ proto3.makeMessageType(
  "fusebase.app_analytics.v1.UserExitedBlockEditMode",
  () => [
    { no: 1, name: "block_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "block_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 100, name: "as_string", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fusebase.app_analytics.v1.UserRequestedPortalAccess
 */
const UserRequestedPortalAccess = /*@__PURE__*/ proto3.makeMessageType(
  "fusebase.app_analytics.v1.UserRequestedPortalAccess",
  () => [
    { no: 1, name: "portal_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "portal_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "portal_domain", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "user_email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 100, name: "as_string", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fusebase.app_analytics.v1.UserDownloadedFile
 */
const UserDownloadedFile = /*@__PURE__*/ proto3.makeMessageType(
  "fusebase.app_analytics.v1.UserDownloadedFile",
  () => [
    { no: 1, name: "file_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "file_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "file_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 100, name: "as_string", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fusebase.app_analytics.v1.UserUploadedFile
 */
const UserUploadedFile = /*@__PURE__*/ proto3.makeMessageType(
  "fusebase.app_analytics.v1.UserUploadedFile",
  () => [
    { no: 1, name: "file_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "file_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "file_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 100, name: "as_string", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fusebase.app_analytics.v1.UserRenamedFile
 */
const UserRenamedFile = /*@__PURE__*/ proto3.makeMessageType(
  "fusebase.app_analytics.v1.UserRenamedFile",
  () => [
    { no: 1, name: "file_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "old_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "new_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "file_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 100, name: "as_string", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fusebase.app_analytics.v1.UserDeletedFile
 */
const UserDeletedFile = /*@__PURE__*/ proto3.makeMessageType(
  "fusebase.app_analytics.v1.UserDeletedFile",
  () => [
    { no: 1, name: "file_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "file_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 100, name: "as_string", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fusebase.app_analytics.v1.UserViewedVideo
 */
const UserViewedVideo = /*@__PURE__*/ proto3.makeMessageType(
  "fusebase.app_analytics.v1.UserViewedVideo",
  () => [
    { no: 1, name: "video_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "video_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 100, name: "as_string", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fusebase.app_analytics.v1.UserCreatedTask
 */
const UserCreatedTask = /*@__PURE__*/ proto3.makeMessageType(
  "fusebase.app_analytics.v1.UserCreatedTask",
  () => [
    { no: 1, name: "task_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "task_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 100, name: "as_string", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fusebase.app_analytics.v1.UserDeletedTask
 */
const UserDeletedTask = /*@__PURE__*/ proto3.makeMessageType(
  "fusebase.app_analytics.v1.UserDeletedTask",
  () => [
    { no: 1, name: "task_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "task_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 100, name: "as_string", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fusebase.app_analytics.v1.UserFollowedLink
 */
const UserFollowedLink = /*@__PURE__*/ proto3.makeMessageType(
  "fusebase.app_analytics.v1.UserFollowedLink",
  () => [
    { no: 1, name: "from_ui_element", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "to_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 100, name: "as_string", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fusebase.app_analytics.v1.RawEvent
 */
const RawEvent = /*@__PURE__*/ proto3.makeMessageType(
  "fusebase.app_analytics.v1.RawEvent",
  () => [
    { no: 1, name: "user_viewed_page", kind: "message", T: UserViewedPage, oneof: "variant" },
    { no: 2, name: "user_entered_block_edit_mode", kind: "message", T: UserEnteredBlockEditMode, oneof: "variant" },
    { no: 3, name: "user_exited_block_edit_mode", kind: "message", T: UserExitedBlockEditMode, oneof: "variant" },
    { no: 4, name: "user_uploaded_file", kind: "message", T: UserUploadedFile, oneof: "variant" },
    { no: 5, name: "user_downloaded_file", kind: "message", T: UserDownloadedFile, oneof: "variant" },
    { no: 6, name: "user_renamed_file", kind: "message", T: UserRenamedFile, oneof: "variant" },
    { no: 7, name: "user_deleted_file", kind: "message", T: UserDeletedFile, oneof: "variant" },
    { no: 8, name: "user_viewed_video", kind: "message", T: UserViewedVideo, oneof: "variant" },
    { no: 9, name: "user_created_task", kind: "message", T: UserCreatedTask, oneof: "variant" },
    { no: 10, name: "user_deleted_task", kind: "message", T: UserDeletedTask, oneof: "variant" },
    { no: 11, name: "user_requested_portal_access", kind: "message", T: UserRequestedPortalAccess, oneof: "variant" },
    { no: 12, name: "user_followed_link", kind: "message", T: UserFollowedLink, oneof: "variant" },
  ],
);

/**
 * @generated from message fusebase.app_analytics.v1.Event
 */
const Event = /*@__PURE__*/ proto3.makeMessageType(
  "fusebase.app_analytics.v1.Event",
  () => [
    { no: 1, name: "raw_event", kind: "message", T: RawEvent },
    { no: 1000, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 1002, name: "timestamp", kind: "message", T: Timestamp },
    { no: 1006, name: "context", kind: "message", T: EventContext },
    { no: 1005, name: "user", kind: "message", T: User },
    { no: 1004, name: "session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fusebase.app_analytics.v1.EventSort
 */
const EventSort = /*@__PURE__*/ proto3.makeMessageType(
  "fusebase.app_analytics.v1.EventSort",
  () => [
    { no: 1, name: "field", kind: "enum", T: proto3.getEnumType(EventSortField) },
    { no: 2, name: "descending", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fusebase.app_analytics.v1.EventFilter
 */
const EventFilter = /*@__PURE__*/ proto3.makeMessageType(
  "fusebase.app_analytics.v1.EventFilter",
  () => [
    { no: 1, name: "context_filter", kind: "message", T: EventContextFilter },
  ],
);

/**
 * @generated from message fusebase.app_analytics.v1.ListEventsRequest
 */
const ListEventsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fusebase.app_analytics.v1.ListEventsRequest",
  () => [
    { no: 1, name: "filter", kind: "message", T: EventFilter },
    { no: 2, name: "sort", kind: "message", T: EventSort },
    { no: 3, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fusebase.app_analytics.v1.ListEventsResponse
 */
const ListEventsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fusebase.app_analytics.v1.ListEventsResponse",
  () => [
    { no: 1, name: "events", kind: "message", T: Event, repeated: true },
    { no: 2, name: "next_page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);


exports.EventSortField = EventSortField;
exports.UserViewedPage = UserViewedPage;
exports.UserEnteredBlockEditMode = UserEnteredBlockEditMode;
exports.UserExitedBlockEditMode = UserExitedBlockEditMode;
exports.UserRequestedPortalAccess = UserRequestedPortalAccess;
exports.UserDownloadedFile = UserDownloadedFile;
exports.UserUploadedFile = UserUploadedFile;
exports.UserRenamedFile = UserRenamedFile;
exports.UserDeletedFile = UserDeletedFile;
exports.UserViewedVideo = UserViewedVideo;
exports.UserCreatedTask = UserCreatedTask;
exports.UserDeletedTask = UserDeletedTask;
exports.UserFollowedLink = UserFollowedLink;
exports.RawEvent = RawEvent;
exports.Event = Event;
exports.EventSort = EventSort;
exports.EventFilter = EventFilter;
exports.ListEventsRequest = ListEventsRequest;
exports.ListEventsResponse = ListEventsResponse;
